<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-21 15:06:07
-->
<template>
  <div class="contain">
    <!-- <div class="header">工商信息</div> -->
    <div>
      <table>
        <tr>
          <td>企业名称</td>
          <td>{{ toHtmlStr(business.entName) }}</td>
          <td>注册资本</td>
          <td>{{ business.regCap }}</td>
          <td>经营状态</td>
          <td>{{ toHtmlStr(business.entStatus) }}</td>
        </tr>
        <tr>
          <td>企业类型</td>
          <td>{{ toHtmlStr(business.entType) }}</td>
          <td>统一社会信用代码</td>
          <td>{{ toHtmlStr(business.creditCode) }}</td>
          <td>成立日期</td>
          <td>{{ toHtmlStr(business.openFrom) }}</td>
        </tr>
        <tr>
          <td>法定代表人</td>
          <td>{{ toHtmlStr(business.frName) }}</td>
          <td>核准时间</td>
          <td>{{ toHtmlStr(business.apprDate) }}</td>
          <td>行业门类名称</td>
          <td>
            {{ toHtmlStr(business.industryPhyName) }}
          </td>
        </tr>
        <tr>
          <td>经营期限</td>
          <td>{{ toHtmlStr(business.openTo) }}</td>
          <td>注册代码</td>
          <td>{{ toHtmlStr(business.regNo) }}</td>
          <td>登记机关</td>
          <td>{{ toHtmlStr(business.regOrg) }}</td>
        </tr>
        <tr>
          <td>国民经济行业名称（代码）</td>
          <td>{{ toHtmlStr(business.industryCode) }}</td>
          <td>所属地区</td>
          <td colspan="3">
            {{ toHtmlStr(business.province) }}{{ toHtmlStr(business.city)
            }}{{ toHtmlStr(business.county) }}
          </td>
        </tr>
        <tr>
          <td>经营范围</td>
          <td colspan="6">{{ toHtmlStr(business.operateScope) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { toHtmlStr } from '@utils'
import { getEntOpen } from '@api/corporateInteraction/enterprise'
export default {
  props: {
    entName: {
      type: String,
      default: ''
    },
    creditCode: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      toHtmlStr,
      business: {}
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getEntOpen()
  },
  methods: {
    /** 获取工商信息 */
    getEntOpen() {
      getEntOpen({
        creditCode: this.creditCode,
        entName: this.entName
      }).then(res => {
        if (res.data.code == '0000') {
          this.business = res.data.data
          this.business.regCap = this.business.regCap
            ? this.business.regCap + '万元'
            : '-'
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  .header {
    color: rgba(255, 255, 255, 100);
    font-size: 0.16rem;
    margin-bottom: 0.16rem;
    &::before {
      content: '';
      vertical-align: middle;
      width: 0.03rem;
      height: 0.18rem;
      display: inline-block;
      margin-right: 0.1rem;
      background: #00fffe;
    }
  }
  table {
    width: 100%;
    border-collapse: collapse;
    color: rgba(255, 255, 255, 100);
    font-size: 0.16rem;
    border: 1px solid rgba(46, 178, 236, 1);
    td {
      border: 1px solid rgba(46, 178, 236, 0.5);
    }
    tr {
      > td:nth-child(odd) {
        color: rgba(0, 255, 254, 100);
        background-color: rgba(0, 103, 166, 0.35);
        text-align: center;
        padding: 0.18rem 0.2rem;
      }
      > td:nth-child(even) {
        width: 3.4rem;
        padding: 0.18rem 0.2rem;
      }
    }
  }
}
</style>
